var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AbstractEndpoint = require('../endpoint');

module.exports =
/*#__PURE__*/
function (_AbstractEndpoint) {
  "use strict";

  _inherits(CommerceEndpoint, _AbstractEndpoint);

  function CommerceEndpoint() {
    _classCallCheck(this, CommerceEndpoint);

    return _possibleConstructorReturn(this, _getPrototypeOf(CommerceEndpoint).apply(this, arguments));
  }

  _createClass(CommerceEndpoint, [{
    key: "delivery",
    // Current things to grab in the delivery box
    value: function delivery() {
      return new DeliveryEndpoint(this);
    } // Current gem/coin exchange rates

  }, {
    key: "exchange",
    value: function exchange() {
      return new ExchangeEndpoint(this);
    } // Current tradingpost listings

  }, {
    key: "listings",
    value: function listings() {
      return new ListingsEndpoint(this);
    } // Current tradingpost prices

  }, {
    key: "prices",
    value: function prices() {
      return new PricesEndpoint(this);
    } // Current and completed transactions

  }, {
    key: "transactions",
    value: function transactions() {
      var _this = this;

      return {
        current: function current() {
          return {
            buys: function buys() {
              return new TransactionsEndpoint(_this, 'current', 'buys');
            },
            sells: function sells() {
              return new TransactionsEndpoint(_this, 'current', 'sells');
            }
          };
        },
        history: function history() {
          return {
            buys: function buys() {
              return new TransactionsEndpoint(_this, 'history', 'buys');
            },
            sells: function sells() {
              return new TransactionsEndpoint(_this, 'history', 'sells');
            }
          };
        }
      };
    }
  }]);

  return CommerceEndpoint;
}(AbstractEndpoint);

var DeliveryEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint2) {
  "use strict";

  _inherits(DeliveryEndpoint, _AbstractEndpoint2);

  function DeliveryEndpoint(client) {
    var _this2;

    _classCallCheck(this, DeliveryEndpoint);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(DeliveryEndpoint).call(this, client));
    _this2.url = "/v2/commerce/delivery";
    _this2.isAuthenticated = true;
    _this2.cacheTime = 5 * 60;
    return _this2;
  }

  return DeliveryEndpoint;
}(AbstractEndpoint);

var ExchangeEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint3) {
  "use strict";

  _inherits(ExchangeEndpoint, _AbstractEndpoint3);

  function ExchangeEndpoint(client) {
    var _this3;

    _classCallCheck(this, ExchangeEndpoint);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ExchangeEndpoint).call(this, client));
    _this3.url = '/v2/commerce/exchange';
    _this3.cacheTime = 10 * 60;
    return _this3;
  }

  _createClass(ExchangeEndpoint, [{
    key: "gems",
    value: function gems(quantity) {
      return _get(_getPrototypeOf(ExchangeEndpoint.prototype), "get", this).call(this, "/gems?quantity=".concat(quantity), true);
    }
  }, {
    key: "coins",
    value: function coins(quantity) {
      return _get(_getPrototypeOf(ExchangeEndpoint.prototype), "get", this).call(this, "/coins?quantity=".concat(quantity), true);
    }
  }]);

  return ExchangeEndpoint;
}(AbstractEndpoint);

var ListingsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint4) {
  "use strict";

  _inherits(ListingsEndpoint, _AbstractEndpoint4);

  function ListingsEndpoint(client) {
    var _this4;

    _classCallCheck(this, ListingsEndpoint);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(ListingsEndpoint).call(this, client));
    _this4.url = '/v2/commerce/listings';
    _this4.isPaginated = true;
    _this4.isBulk = true;
    _this4.supportsBulkAll = false;
    _this4.cacheTime = 2 * 60;
    return _this4;
  }

  return ListingsEndpoint;
}(AbstractEndpoint);

var PricesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint5) {
  "use strict";

  _inherits(PricesEndpoint, _AbstractEndpoint5);

  function PricesEndpoint(client) {
    var _this5;

    _classCallCheck(this, PricesEndpoint);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(PricesEndpoint).call(this, client));
    _this5.url = '/v2/commerce/prices';
    _this5.isPaginated = true;
    _this5.isBulk = true;
    _this5.supportsBulkAll = false;
    _this5.cacheTime = 60;
    return _this5;
  }

  return PricesEndpoint;
}(AbstractEndpoint);

var TransactionsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint6) {
  "use strict";

  _inherits(TransactionsEndpoint, _AbstractEndpoint6);

  function TransactionsEndpoint(client, type, list) {
    var _this6;

    _classCallCheck(this, TransactionsEndpoint);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(TransactionsEndpoint).call(this, client));
    _this6.url = "/v2/commerce/transactions/".concat(type, "/").concat(list);
    _this6.isPaginated = true;
    _this6.isAuthenticated = true;
    _this6.cacheTime = 10 * 60;
    return _this6;
  }

  return TransactionsEndpoint;
}(AbstractEndpoint);